import {
  NOTIFICATION_SECTION,
  type Notification
} from "../types/notification.types.ts"

// Reading can only take a row out of Needs Attention, never put it there. The
// members go with it: reading a collapsed row reads every update behind it.
export function markNotificationRead(notification: Notification): Notification {
  return {
    ...notification,
    unread: false,
    section: NOTIFICATION_SECTION.RECENT_UPDATES,
    ...(notification.group_members && {
      group_members: notification.group_members.map(markNotificationRead)
    })
  }
}
